<script lang="ts">
	import type { VideoData } from '$lib/tools/cms/DatoCMSQueries';
	import { Play } from '@icons';
	import { cookies } from '@tools';

	let {
		data,
		isPlaying = $bindable(false),
		onPlay
	}: { data: VideoData; isPlaying?: boolean; onPlay?: () => void } = $props();

	let hasStarted = $state(false);

	let iframe: HTMLIFrameElement | undefined = $state(undefined);
	let player: YT.Player | undefined;

	$effect(() => {
		if (iframe && data.provider === 'youtube' && window.YT !== undefined) {
			player = new window.YT.Player(iframe, {
				events: {
					onStateChange: (e: any) => {
						if (e.data === window.YT.PlayerState.PLAYING) {
							isPlaying = true;
							onPlay?.();
						}
					}
				}
			});
		}

		return () => {
			player?.destroy();
			player = undefined;
		};
	});

	$effect(() => {
		if (isPlaying && !hasStarted) {
			hasStarted = true;
		} else if (isPlaying && player) {
			player.playVideo?.();
		} else if (!isPlaying && player) {
			player.pauseVideo?.();
		}
	});
</script>

{#if data.provider === 'youtube'}
	<div class="container ExternalVideo" style:aspect-ratio={data.width / data.height}>
		{#if !hasStarted}
			<button
				onclick={() => {
					isPlaying = true;
					onPlay?.();
				}}
				title={data.title}
			>
				<Play />
				<img
					src={data.thumbnailUrl}
					alt={`Forhåndsvisning af ${data.title} video`}
					loading="lazy"
				/>
			</button>
		{:else if !cookies.consents.get('marketing')}
			<button class="blocked" onclick={() => cookies.renewConsent()}>
				<Play />
				<p>Venligst accepter <em>marketingcookies</em> for at se dette {data.provider}-indhold</p>
			</button>
		{:else if data.provider === 'youtube'}
			<iframe
				id={data.providerUid}
				style="border:none;"
				allow="accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				frameborder="0"
				allowfullscreen
				title={data.title}
				src={`https://www.youtube.com/embed/${data.providerUid}?autoplay=1&rel=0&color=white&enablejsapi=1&origin=${window.location.origin}`}
				bind:this={iframe}
			></iframe>
		{:else if data.provider === 'vimeo'}
			<iframe
				id={data.providerUid}
				style="border:none;"
				allow="accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				frameborder="0"
				allowfullscreen
				title={data.title}
				src={`https://player.vimeo.com/video/${data.providerUid}`}
			></iframe>
		{:else if data.provider === 'facebook'}
			<h1>TODO: Implement Facebook</h1>
		{/if}
	</div>
{/if}

<style lang="scss">
	.container {
		display: flex;
		position: relative;
		overflow: hidden;
		background-color: $colorCardBackground;
		color: $colorCardForeground;
	}

	iframe {
		background-color: $colorCardBackground;
	}

	button {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;

		:global(svg) {
			min-width: 10%;
			min-height: 10%;
			height: 5em;
			width: 5em;
			max-width: 50%;
			max-height: 50%;
			position: relative;
			z-index: 2;
		}

		&:hover img {
			transform: scale(1.025);
			transition: transform 0.2s ease-out;
		}
	}

	.blocked {
		background: radial-gradient(closest-side, $colorCardGraphic 100%, rgba(0, 0, 0, 0) 100%);
		background-repeat: repeat-x;
		background-size: calc(100% / 3) 100%;
	}

	p {
		position: absolute;
		text-align: center;
		padding: 1em;
		z-index: 2;
		margin: 0;
		top: 55%;
		margin-top: 0.5em;
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		z-index: 1;
		transition: transform 0.4s ease-out;
	}

	iframe {
		width: 100%;
		height: 100%;
	}
</style>
